import { useState } from 'react';

import { useDispatch } from 'react-redux';

import { getAccPath } from 'api/auth';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { LINK_COPIED } from 'constants/texts';
import { useSnackbar } from 'hooks/useSnackbar';
import useValidationSchema from 'hooks/useValidationSchema';
import { updateTourRequestRecentEventAction } from 'store/admin/itineraries';
import { shareWithUserTypeThunk } from 'store/admin/itineraries/thunks';
import axiosApi from 'utils/axios';
import { copyTextToClipboard } from 'utils/common';
import {
  getSharingLinkByItinerariesItemType,
  ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP,
} from 'utils/itineraries/functions';
import logger from 'utils/logger';

import { SHARE_TYPE } from '../constants';
import getValidationSchema from './validationSchema';

function useForm(props) {
  const { itemId, itinerariesItem, closeModal, shareWithType, itinerariesItemType } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const validate = useValidationSchema(getValidationSchema());
  const onSnackbar = useSnackbar();

  const link = getSharingLinkByItinerariesItemType(itinerariesItemType, itinerariesItem);
  const handleCopyLink = (realLink = link) => {
    if (itinerariesItemType === ITINERARIES_ITEM_TYPES.GUEST_PORTAL) {
      return;
    }

    copyTextToClipboard(realLink);

    if (shareWithType !== SHARE_TYPE.FRIEND) {
      axiosApi
        .post(`${getAccPath()}/${ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP[itinerariesItemType]}/${itemId}/copy_link`)
        .then(({ data = {} }) => {
          dispatch(updateTourRequestRecentEventAction({ id: itemId, recentEvent: data, itinerariesItemType }));

          onSnackbar(LINK_COPIED);
        })
        .catch(() => {
          onSnackbar('Error has occurred', true);
        });
    } else {
      onSnackbar(LINK_COPIED);
    }
  };

  const handleSaveLink = async (tail) => {
    if (/[\\/:*?"<>|&%.'#[\]+=„]/.test(tail)) {
      throw "Invalid characters. You can't use spaces or any of the following \\/:*?\"<>|&%.'#[]+=„";
    }

    const source = ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP[itinerariesItemType];
    await axiosApi.post(`${getAccPath()}/${source}/${itemId}/tail`, { tail });
  };

  const loadTailInfo = async () => {
    const source = ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP[itinerariesItemType];
    const resp = await axiosApi.get(`${getAccPath()}/${source}/${itemId}/tail`);
    return resp.data.data;
  };

  const handleSubmit = async (values) => {
    const emails = values?.clients?.map((client) => client?.email)?.join(', ');
    try {
      setLoading(true);
      await dispatch(shareWithUserTypeThunk({ id: itemId, itinerariesItemType, ...values }, shareWithType));
      onSnackbar(`Email has been sent to: ${emails}`);
      closeModal();
    } catch (e) {
      onSnackbar('Oops! Something went wrong', true);
      logger.error(`[Share] error: '${JSON.stringify(e)}'`);
    } finally {
      setLoading(false);
    }
  };

  return {
    validate,
    handleSubmit,
    handleCopyLink,
    handleSaveLink,
    loadTailInfo,
    link,
    loading,
  };
}

export default useForm;
